import { render, staticRenderFns } from "./TrainingGroupFolder.vue?vue&type=template&id=2d5db071&scoped=true&"
import script from "./TrainingGroupFolder.vue?vue&type=script&lang=js&"
export * from "./TrainingGroupFolder.vue?vue&type=script&lang=js&"
import style0 from "./TrainingGroupFolder.vue?vue&type=style&index=0&id=2d5db071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5db071",
  null
  
)

export default component.exports